import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import type { AddProductsSourceKey } from '../../Tabs/ProductsTableBody/model/useAddProductsTransfer';
import type { ProposalShortageItem, ProposalShortageKind } from '../model/types';
import ShortageTableBody from './ShortageTableBody';

interface ProductSourceOption {
    key: AddProductsSourceKey;
}

interface ShortageTableProps {
    kind: ProposalShortageKind;
    items: ProposalShortageItem[];
    proposalName: string;
    showActions: boolean;
    canAdd: boolean;
    sources: ProductSourceOption[];
    teamName: string;
    openTransfer: (key: AddProductsSourceKey, productId?: number) => void;
}

const ShortageTable = ({
    kind,
    items,
    proposalName,
    showActions,
    canAdd,
    sources,
    teamName,
    openTransfer,
}: ShortageTableProps) => {
    const { t } = useTranslation(['Objects']);

    return (
        <div className="proposal-shortage__table-wrap">
            <Table size="sm" className="proposal-shortage__table mb-0 align-middle">
                <thead>
                    <tr>
                        <th>{t('proposalShortage.colName')}</th>
                        <th className="text-end">{t('proposalShortage.colNeed')}</th>
                        <th className="text-end">{t('proposalShortage.colHave')}</th>
                        <th className="text-end">{t('proposalShortage.colDeficit')}</th>
                        {showActions && (
                            <th className="text-end">{t('proposalShortage.colActions')}</th>
                        )}
                    </tr>
                </thead>
                <ShortageTableBody
                    kind={kind}
                    items={items}
                    proposalName={proposalName}
                    showActions={showActions}
                    canAdd={canAdd}
                    sources={sources}
                    teamName={teamName}
                    openTransfer={openTransfer}
                />
            </Table>
        </div>
    );
};

export default ShortageTable;
